import BaseProxy from "../../base-proxy";
const TARGET_URL = "/company-subscriptions/apply-for-external-payment";

/**
 * @class ApplyForSubscriptionManualPaymentProxy
 * @description Class used for communicating with applying for manual payment API.
 * @author Koh Keng Hong
 * @version 1.0
 * @since December 18, 2018
 */
export default class ApplyForSubscriptionManualPaymentProxy {
  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param data - Generic data parameter instance.
   * @param {String} input.expected_pay_at - Expected payment date.
   * @param {String} input.cheque_number - Cheque number (optional).
   * @param {Array} input.companySubscriptionIds - Company Subscription Ids.
   * @param {String} data.authToken - Token used for issuing authenticated request.
   * @param {String} data.id - Company id.
   */
  async execute(data = {}, input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let subscriptionIds =
      input.companySubscriptionIds == null
        ? null
        : input.companySubscriptionIds.map((subscriptionId) => `companySubscriptionIds=${subscriptionId}`).join("&");
    let endpointUrl = `${backendUrl}${TARGET_URL}?${subscriptionIds}`;

    return await baseProxy.postAuthenticatedData(endpointUrl, data.authToken, input);
  }
}
